<template>
  <!-- 请提供包含 router-link 的模板部分 -->
  <router-link to="/"></router-link>
  <!-- 确认存在路由出口 -->
  <router-view></router-view>
  <Home v-if="false"/>
  <PdtList v-if="false"></PdtList>
  <PdtDesc  v-if="false"></PdtDesc>
  <AboutUs v-if="false"></AboutUs>
  <ContactUs  v-if="false"></ContactUs>
</template>

<script>
import Home from './components/Home.vue'
import PdtList from './components/PdtList'
import PdtDesc from './components/PdtDesc'
import AboutUs from './components/AboutUs'
import ContactUs from './components/ContactUs'


export default {
  name: 'App',
  components: {
    Home,PdtList,PdtDesc,AboutUs,ContactUs
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0;
  padding: 0;
}
</style>
